/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const typeNodeInputClientIdMax = 36;

export const typeNodeInputClientIdRegExp = new RegExp('^[a-z0-9._:-]+$');

export const typeNodeInputTypeDefinitionReferenceViewPredicatesItemPathTypeUuidsMax = 8;

export const typeNodeInputTypeDefinitionReferenceViewPredicatesMax = 10;

export const typeNodeInputTypeDefinitionReferenceViewSearchTermsItemMax = 200;

export const typeNodeInputTypeDefinitionReferenceViewSearchTermsMax = 10;

export const TypeNodeInput = zod.object({
  clientId: zod
    .string()
    .min(1)
    .max(typeNodeInputClientIdMax)
    .regex(typeNodeInputClientIdRegExp)
    .describe(
      'Caller-supplied temporary node reference, unique within the request. Used to wire edges and to look up the created UUID in the response. Use lowercase letters, numbers, dots, underscores, colons, or hyphens.',
    ),
  contentTypeUuid: zod
    .uuid()
    .optional()
    .describe(
      "Optional reference to another TYPE — a complex type's field slot points at the primitive it instantiates, or a parent TYPE for type→type grouping.",
    ),
  typeDefinition: zod
    .object({
      conformance: zod.enum(['open', 'lax', 'strict']).optional(),
      description: zod.string().nullish(),
      enumOptions: zod
        .array(zod.string().min(1))
        .optional()
        .describe(
          'Ordered choice values for an ENUM type (one string per option). Stored as { value, label } with value === label.',
        ),
      file: zod
        .object({
          allowedFormats: zod
            .array(
              zod.enum([
                'pdf',
                'doc',
                'docx',
                'xls',
                'xlsx',
                'csv',
                'txt',
                'jpeg',
                'png',
                'webp',
                'gif',
                'heic',
                'md',
                'html',
                'mp3',
                'm4a',
                'wav',
                'mp4',
                'mov',
                'webm',
              ]),
            )
            .min(1)
            .optional(),
        })
        .nullish()
        .describe(
          'File config for a STRING type whose instances hold uploaded files. allowedFormats narrows the platform allowlist to a subset of format ids; omitted, the field accepts every platform-supported format. Pass null to clear a stored config; omit to keep it.',
        ),
      reference: zod
        .object({
          carbonCopy: zod.boolean().optional(),
          creation: zod.enum(['forbidden', 'optional', 'required']).optional(),
          edgeType: zod.enum(['INCLUDES', 'RELATES_TO']).optional(),
          typeLineageUuid: zod.uuid(),
          typeUuid: zod.uuid(),
          view: zod
            .object({
              predicates: zod
                .array(
                  zod.object({
                    op: zod.enum(['exists', 'eq', 'contains', 'gte', 'lte']),
                    pathTypeUuids: zod
                      .array(zod.uuid())
                      .min(1)
                      .max(typeNodeInputTypeDefinitionReferenceViewPredicatesItemPathTypeUuidsMax),
                    value: zod.string().optional(),
                    valueType: zod
                      .enum(['STRING', 'NUMERIC', 'BOOLEAN', 'DATE', 'DATETIME'])
                      .optional(),
                  }),
                )
                .max(typeNodeInputTypeDefinitionReferenceViewPredicatesMax)
                .optional(),
              searchTerms: zod
                .array(
                  zod
                    .string()
                    .min(1)
                    .max(typeNodeInputTypeDefinitionReferenceViewSearchTermsItemMax),
                )
                .max(typeNodeInputTypeDefinitionReferenceViewSearchTermsMax)
                .optional(),
            })
            .nullish(),
        })
        .nullish()
        .describe(
          "Reference config for a STRING type whose instances point at another TYPE's instances. Pass null to clear a stored config; omit to keep it.",
        ),
    })
    .optional(),
  typeName: zod.string().min(1).describe('Schema field\/type name for this TYPE node.'),
  value: zod
    .object({
      booleanValue: zod.boolean().nullish(),
      dateValue: zod.string().nullish(),
      datetimeValue: zod.string().nullish(),
      jsonValue: zod.unknown().optional(),
      numericValue: zod.number().nullish(),
      stringValue: zod.string().nullish(),
    })
    .optional(),
  valueType: zod
    .enum(['STRING', 'NUMERIC', 'BOOLEAN', 'DATE', 'DATETIME', 'ENUM', 'JSON'])
    .optional()
    .describe('Datatype of a TYPE leaf field.'),
});

export type TypeNodeInput = zod.input<typeof TypeNodeInput>;
export type TypeNodeInputOutput = zod.output<typeof TypeNodeInput>;
